export default __webpack_public_path__ + "static/media/implant.c3669bbe.svg";